var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInventory = function SvgInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "inventory_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3832_82626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3832_82626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "inventory_2_2",
    d: "M9 44C8.175 44 7.46883 43.7062 6.8815 43.1185C6.29383 42.5312 6 41.825 6 41V16.85C5.43333 16.65 4.95833 16.2935 4.575 15.7805C4.19167 15.2675 4 14.674 4 14V7C4 6.175 4.29383 5.46867 4.8815 4.881C5.46883 4.29367 6.175 4 7 4H41C41.825 4 42.5313 4.29367 43.119 4.881C43.7063 5.46867 44 6.175 44 7V14C44 14.674 43.8083 15.2675 43.425 15.7805C43.0417 16.2935 42.5667 16.65 42 16.85V41C42 41.825 41.7063 42.5312 41.119 43.1185C40.5313 43.7062 39.825 44 39 44H9ZM9 17V41H39V17H9ZM7 14H41V7H7V14ZM19.5 27H28.5C28.925 27 29.2813 26.8553 29.569 26.566C29.8563 26.277 30 25.9187 30 25.491C30 25.0637 29.8563 24.7083 29.569 24.425C29.2813 24.1417 28.925 24 28.5 24H19.5C19.075 24 18.7188 24.1447 18.4315 24.434C18.1438 24.723 18 25.0813 18 25.509C18 25.9363 18.1438 26.2917 18.4315 26.575C18.7188 26.8583 19.075 27 19.5 27Z",
    fill: "#B6C2D6"
  })))));
};
export default SvgInventory;